import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { InputItem } from "../forms/FormItems";
import CheckBoxItem from "../forms/CheckBoxItem";
import AddEntityForm from "../../components/templates/AddEntityForm";

const NewTariff = (props) => {
  const { hide, addText, createRecord, loading, type } = props;
  const dispatch = useDispatch();

  const onFinish = async (values) => {
    const tariff = {
      name: values.name,
      description: values.description,
      is_default: values.is_default,
      tariff_versions: [
        {
          base_rate: values.base_rate,
        },
      ],
    };

    const action = await dispatch(createRecord(tariff));
    if (!action.error) {
      hide();
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onDecline = () => {
    hide();
  };

  const items = [
    {
      name: "name",
      required: true,
      comp: <InputItem name="name" category="tariff" required={true} />,
    },

    {
      name: "description",
      comp: <InputItem name="description" category="tariff" />,
    },
    {
      name: "base_rate",
      required: true,
      comp: (
        <InputItem
          name="base_rate"
          category="tariff"
          required={true}
          number={true}
          twoDigitsNumbers={true}
          onlyPositiveNumbers={true}
        />
      ),
    },
    ...(type === "wage"
      ? [
          {
            name: "is_default",
            comp: (
              <CheckBoxItem
                showLabel={true}
                name="is_default"
                category="tariff"
              />
            ),
          },
        ]
      : []),
  ];

  return (
    <AddEntityForm
      resource="users"
      action="editor"
      items={items}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      onDecline={onDecline}
      saveLoading={loading}
      addText={addText}
    />
  );
};

NewTariff.propTypes = {
  hide: PropTypes.func,
  addText: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

export default NewTariff;
